<template lang="pug">
  div
    el-dialog(
      title='Solicitar retificação'
      :visible.sync='showModal'
       width='60%'
       v-loading='loading'
    )
      div
        span.historico Histórico de retificação
        el-collapse(
          v-for='(conversa, index) in historico.content'
          :key='index'
          v-model='panelAtiva[index]'
          accordion
          style='padding: 20px 0px 20px 0px;'
        )
          div.assunto-historico {{ conversa.assunto }}
          el-collapse-item(v-for="(mensagem, index) in conversa.mensagens" :key="index")
            template(slot='title')
              .title-content
                div
                  span {{ mensagem.remetente.nomeRazaoSocial }}
                div
                  span {{ mensagem.dataEnviada | timestamp }}
            span(v-html='mensagem.conteudo')
      el-form(
        :rules='rules'
        ref='formRetificar'
        :model='formRetificar'
        label-position='top'
      )
        el-row
          el-col(:span='16')
            .assunto {{ assuntoRetificacao }}
          el-col.prazo(:span='8' style='margin-bottom: -50px;')
            el-form-item(label='Prazo para resposta' prop='prazo')
              el-date-picker(
                v-model='formRetificar.prazo'
                placeholder='Selecione'
                type='date'
                :picker-options='pickerOptions'
                style='z-index: 9'
                format="dd/MM/yyyy"
              )
        el-row
          el-form-item(label='Especifique os campos a serem retificados no cadastro:' prop='mensagem')
            vue-editor(v-model='formRetificar.mensagem' :editor-toolbar='customToolbar')

      el-row(type='flex' justify='space-between')
        el-button(@click='fecharModal')
          i(style='padding-right: 5px;').fa.fa-times
          span Cancelar
        el-button(
          type='primary'
          @click='solicitarRetificacao'
        )
          i(style='padding-right: 5px;').fa.fa-share-square
          span Enviar
</template>
<script>
import { VueEditor } from 'vue2-editor';
import { AppNotificacao } from 'sicarf-components';
import { retificar } from '@/services/solicitacaoCredenciadoService';
import { listConversasBySolicitacao } from '@/services/conversaService';
import { TIPO_CONVERSA } from '@/constants/constants.js';

export default {
  components: {
    VueEditor,
  },
  mixins: [
    AppNotificacao
  ],
  props: {
    solicitacao: {
      type: Object,
      required: true,
    },
    modalOpen: {
      type: Boolean,
      default: false,
    },
    dataFimEdital: {
      required: true
    }
  },
  computed: {
    showModal: {
      get() {
        return this.modalOpen;
      },
      set() {
        this.$emit('close-modal');
      }
    }
  },
  data() {
    return {
      historico: [],
      panelAtiva: [],
      rules: {
        mensagem: [
          { required: true, message: 'A mensagem é obrigatória', trigger: 'blur' }
        ],
        prazo: [
          { required: true, message: 'Defina um prazo', trigger: 'blur' }
        ],
      },
      customToolbar: [
        ['bold', 'italic', 'underline', 'strike'],
        [{ list: 'ordered' }, { list: 'bullet' }],
        [{ align: '' }, { align: 'center' }, { align: 'right' }, { align: 'justify' }],
        [{ clean: true }],
      ],
      formRetificar: {
        mensagem: '',
        prazo: null,
      },
      pickerOptions: {
        disabledDate: this.disabledDate
      },
      loading: false,
      assuntoRetificacao: '',
    }
  },
  async mounted() {
    this.loading = true;
    this.assuntoRetificacao = `Assunto: Solicitar retificação - edital nº ${this.solicitacao.edital.numero}`;
    this.historico = await listConversasBySolicitacao(this.solicitacao.id, TIPO_CONVERSA.SOLICITACAO_RETIFICACAO, 0, 999999);

    if (this.historico && this.historico.content.length > 0) {
      this.conversa = this.historico.content[this.historico.content.length - 1];
    }

    if (!this.conversa) {
      this.modalTitle = 'Notificar credenciado';
    } else {
      this.modalTitle = 'Notificações';
    }

    this.loading = false;
  },

  methods: {

    fecharModal() {
      this.$emit('close-modal');
    },

    async solicitarRetificacao() {
      let dto = null;
      this.$refs.formRetificar.validate((valid) => {
        if (valid) {
          this.loading = true;
          dto = {};
          dto.assunto = this.assuntoRetificacao;
          dto.mensagem = this.formRetificar.mensagem;
          dto.dataLimiteResposta = this.formRetificar.prazo;
          dto.destinatario = { id: this.solicitacao.credenciado.pessoa.id }
        };
      });

      if (dto !== null) {
        await retificar(this.solicitacao.id, dto)
        this.showNotificacao(
          this.$messages.TIPO_SUCCESS,
          this.$messages.TITULO_SUCCESS,
          this.$messages.RETIFICACAO_SOLICITADA,
        )

        this.$emit('retificar');
        this.loading = false;
      };
      this.loading = false;
    },
    disabledDate(time) {
      const dataFimEditalPlus30 = new Date(this.dataFimEdital)
      dataFimEditalPlus30.setDate(dataFimEditalPlus30.getDate() + 30)
      return time.getTime() > dataFimEditalPlus30.getTime();
    },
  }
}
</script>
<style lang="scss" scoped>
.divider {
  border: 1px solid #dfe4ed;
  margin-bottom: 10px;
  margin-top: 10px;
}

.title {
  font-weight: bold;
  font-size: 16px;
  padding-left: 10px;
}

.label {
  font-weight: bold;
  font-size: 15px;
  padding-left: 10px;
}

.paddingTop20 {
  padding-top: 20px;
}

.marginBottom60 {
  margin-bottom: 60px;
}

.el-upload__text {
  background: #d9d9d9;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 1rem;
  line-height: 2em;
  height: 7rem;
}

.botao-modelo {
  z-index: 9;
}

.selecionar-modelo {
  display: flex;
  justify-content: flex-end;
  margin-bottom: -70px;
}

.title-content {
  font-size: 16px;
  display: flex;
  justify-content: space-between;
  width: 100%;
}

.historico {
  font-weight: bold;
  font-size: 20px;
  margin-bottom: 25px;
}

.assunto {
  font-weight: bold;
  font-size: 20px;
  margin-bottom: 25px;
}

.prazo {
  display: flex;
  justify-content: flex-end;
}

.assunto-historico {
  font-weight: bold;
  font-size: 18px;
  margin-bottom: 25px;
  margin-left: 20px;
}

</style>
